import React from 'react'

import { HomePage } from './pages/home.page'
import './assets/app.css'

function App() {
  return (
    <div className="App">
      <HomePage />
    </div>
  )
}

export default App
